// 결정 시트 3종 — A3-1 매입가 / A3-2 매입 안 함 / A3-3 신청 취소.
// 금전 규칙 (BUILD_PLAN §3·§6):
//   · 매입가는 **원 단위**, 서버가 검증하지 않으므로 >0 일 때만 확인 버튼이 활성된다.
//   · 반려 사유는 평가사·관리자(한국인)가 읽는 값 → 화면 언어와 무관하게 **항상 한국어 고정**
//     (앱 simple_not_buy_sheet.dart 의 lookupAppLocalizations(ko) 와 같은 방식 — ko 사전에서 직접 읽는다).
// 확인 버튼에 disabled/진행중이 필요해 ConfirmSheet 대신 SheetFrame + 자체 푸터를 쓴다.
import React, { useState, useEffect } from 'react';
import { T, R } from '../../../theme';
import { useT, LOCALES } from '../../../../i18n/I18nProvider';
import { SheetFrame } from '../../parts/ConfirmSheet';
import LtrText from '../../parts/LtrText';

// 사유 4종 — 라벨은 현재 언어, 전송값은 ko 사전 값.
var REASON_KEYS = ['simpleReasonPrice', 'simpleReasonCondition', 'simpleReasonDocs', 'simpleReasonOther'];

// 취소 사유 코드 2종(바이어 scope, 검차 신청 취소 사유 통지 BUILD_PLAN §0-2·§3) — BUYER_REQUEST 기본 선택.
var CANCEL_CODES = ['BUYER_REQUEST', 'OTHER'];

/// 반려 사유의 서버 전송값(한국어 고정). 화면 로케일과 무관하다.
export function reasonKo(key) {
  return LOCALES.ko[key];
}

var subStyle = { fontSize: 12, color: T.muted, lineHeight: 1.6 };
var labelStyle = { display: 'block', fontSize: 11, fontWeight: 700, color: T.muted, marginBottom: 4 };
var moneyBox = { display: 'flex', alignItems: 'center', gap: 8, height: 44, padding: '0 12px', borderRadius: R.md,
  border: '1px solid ' + T.accentBd, background: T.accentTint, boxSizing: 'border-box' };
var moneyInput = { flex: 1, minWidth: 0, border: 0, background: 'none', outline: 'none', fontFamily: 'inherit',
  fontSize: 19, fontWeight: 800, color: T.ink, direction: 'ltr', textAlign: 'start', fontVariantNumeric: 'tabular-nums' };
var wonMark = { fontSize: 16, fontWeight: 800, color: T.faint, flex: 'none' };
var chips = { display: 'flex', gap: 7, flexWrap: 'wrap' };
var chip = { display: 'inline-flex', alignItems: 'center', height: 29, padding: '0 12px', borderRadius: R.pill,
  border: '1px solid ' + T.bd, background: T.card, fontSize: 12, fontWeight: 600, color: T.body,
  cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' };
var chipOnDanger = Object.assign({}, chip, { border: '1px solid ' + T.dangerBd, background: T.dangerTint, color: T.danger, fontWeight: 700 });
// 취소 사유 라디오 — 제목(short) + 캡션(전문), 세로 목록 (2026-09-23 Jin 앱 정합 지시).
var reasonList = { display: 'flex', flexDirection: 'column', gap: 8 };
var reasonRow = { display: 'flex', flexDirection: 'column', gap: 2, width: '100%', textAlign: 'start',
  padding: '10px 12px', borderRadius: R.md, border: '1px solid ' + T.bd, background: T.card,
  cursor: 'pointer', fontFamily: 'inherit' };
var reasonRowOn = Object.assign({}, reasonRow, { border: '1px solid ' + T.dangerBd, background: T.dangerTint });
var reasonTitle = { fontSize: 13, fontWeight: 700, color: T.body };
var reasonTitleOn = Object.assign({}, reasonTitle, { color: T.danger });
var reasonCaption = { fontSize: 11, color: T.muted, lineHeight: 1.5 };
var textarea = { width: '100%', minHeight: 72, padding: '8px 10px', borderRadius: R.md, border: '1px solid ' + T.bd,
  background: T.card, color: T.ink, fontSize: 13, fontFamily: 'inherit', lineHeight: 1.5, resize: 'vertical', boxSizing: 'border-box' };
var warnTip = { display: 'flex', gap: 8, padding: '10px 12px', borderRadius: R.md, background: T.warnTint,
  border: '1px solid ' + T.warnBd, fontSize: 11.5, color: T.warn, lineHeight: 1.55 };
var row = { display: 'flex', gap: 10 };
var btn = { flex: 1, height: 42, borderRadius: R.md, fontSize: 13.5, fontWeight: 700, cursor: 'pointer',
  fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 0 };
var btnGhost = Object.assign({}, btn, { background: T.card, border: '1px solid ' + T.bd, color: T.body });
var btnNavy = Object.assign({}, btn, { background: T.navy, border: '1px solid ' + T.navy, color: T.card, flex: 2 });
var btnNavyOff = Object.assign({}, btn, { background: T.track, border: '1px solid ' + T.bd, color: T.faint, flex: 2, cursor: 'not-allowed' });
var btnDanger = Object.assign({}, btn, { background: T.danger, border: '1px solid ' + T.danger, color: T.card, flex: 2 });

function parseWon(text) {
  var digits = String(text == null ? '' : text).replace(/[^0-9]/g, '');
  return digits ? parseInt(digits, 10) : 0;
}

function withCommas(won) {
  return won ? Number(won).toLocaleString('en-US') : '';
}

/// A3-1 매입가 시트 — props: { open, busy, onClose, onConfirm(won) }
export function BuyPriceSheet(props) {
  var t = useT();
  var st = useState(0); var won = st[0], setWon = st[1];
  var open = props.open;
  // 열릴 때마다 빈 금액에서 시작 — 직전 입력이 남아 오입력으로 결정되면 안 된다.
  useEffect(function () { if (open) setWon(0); }, [open, setWon]);
  var valid = won > 0 && !props.busy;
  return (<SheetFrame open={open} title={t('simpleBuySheetTitle')} onClose={props.onClose} closeLabel={t('actionClose')}>
    <p style={subStyle}>{t('simpleBuySheetSub')}</p>
    <div>
      <label style={labelStyle} htmlFor="ss-buy-price">{t('evalDecidePurchasePrice')}</label>
      <div style={moneyBox}>
        <LtrText style={wonMark}>₩</LtrText>
        <input id="ss-buy-price" type="text" inputMode="numeric" autoComplete="off" style={moneyInput}
          value={withCommas(won)} onChange={function (e) { setWon(parseWon(e.target.value)); }} />
      </div>
    </div>
    <div style={chips}>
      {[1000000, 100000, 10000].map(function (step) {
        return (<button key={step} type="button" data-bump={step} style={chip}
          onClick={function () { setWon(won + step); }}>
          <LtrText>{'+' + Number(step).toLocaleString('en-US')}</LtrText>
        </button>);
      })}
    </div>
    <div style={row}>
      <button type="button" style={btnGhost} onClick={props.onClose}>{t('actionCancel')}</button>
      <button type="button" disabled={!valid} style={valid ? btnNavy : btnNavyOff}
        onClick={function () { if (valid) props.onConfirm(won); }}>{t('simpleConfirmBuy')}</button>
    </div>
  </SheetFrame>);
}

/// A3-2 매입 안 함 시트 — props: { open, busy, onClose, onConfirm(reasonKo) }
export function NotBuySheet(props) {
  var t = useT();
  var st = useState(''); var sel = st[0], setSel = st[1];
  var open = props.open;
  useEffect(function () { if (open) setSel(''); }, [open, setSel]);
  return (<SheetFrame open={open} title={t('simpleNotBuyConfirmTitle')} onClose={props.onClose} closeLabel={t('actionClose')}>
    <p style={subStyle}>{t('simpleNotBuyConfirmSub')}</p>
    <div style={chips}>
      {REASON_KEYS.map(function (key) {
        var on = sel === key;
        return (<button key={key} type="button" data-reason={key} aria-pressed={on} style={on ? chipOnDanger : chip}
          onClick={function () { setSel(on ? '' : key); }}>{t(key)}</button>);
      })}
    </div>
    <div style={row}>
      <button type="button" style={btnGhost} onClick={props.onClose}>{t('actionCancel')}</button>
      <button type="button" disabled={!!props.busy} style={btnDanger}
        onClick={function () { if (!props.busy) props.onConfirm(sel ? reasonKo(sel) : ''); }}>{t('simpleNotBuy')}</button>
    </div>
  </SheetFrame>);
}

/// A3-3 신청 취소 — props: { open, assigned, busy, onClose, onConfirm({reason_code, reason_note}) }
export function CancelDialog(props) {
  var t = useT();
  var stCode = useState('BUYER_REQUEST'); var code = stCode[0], setCode = stCode[1];
  var stNote = useState(''); var noteText = stNote[0], setNoteText = stNote[1];
  var open = props.open;
  useEffect(function () { if (open) { setCode('BUYER_REQUEST'); setNoteText(''); } }, [open, setCode, setNoteText]);
  return (<SheetFrame open={open} title={t('evalCancelTitle')} onClose={props.onClose} closeLabel={t('actionClose')}>
    <p style={subStyle}>{t('evalCancelMessage')}</p>
    {props.assigned ? <div style={warnTip}>{t('cancelReasonAfterAssignWarn')}</div> : null}
    <div style={reasonList}>
      {CANCEL_CODES.map(function (c) {
        var on = code === c;
        return (<button key={c} type="button" data-reason-code={c} aria-pressed={on} style={on ? reasonRowOn : reasonRow}
          onClick={function () { setCode(c); }}>
          <span style={on ? reasonTitleOn : reasonTitle}>{t('evalCancelReasonShort_' + c)}</span>
          <span style={reasonCaption}>{t('evalCancelReason_' + c)}</span>
        </button>);
      })}
    </div>
    <div>
      <label style={labelStyle} htmlFor="ss-cancel-note">{t('cancelReasonNoteLabelSelf')}</label>
      <textarea id="ss-cancel-note" style={textarea} maxLength={500} placeholder={t('evalCancelReasonHint')}
        value={noteText} onChange={function (e) { setNoteText(e.target.value); }} />
    </div>
    <div style={row}>
      <button type="button" style={btnGhost} onClick={props.onClose}>{t('actionCancel')}</button>
      <button type="button" disabled={!!props.busy} style={btnDanger}
        onClick={function () { if (!props.busy) props.onConfirm({ reason_code: code, reason_note: noteText }); }}>{t('evalActionCancel')}</button>
    </div>
  </SheetFrame>);
}
